import { CompactType, DisplayGrid, GridType } from 'angular-gridster2';

export const GRID_HEIGHT = 75;
export const GRID_WIDTH = 75;

export function gridDefaultValue(isPilotPanel: boolean) {
   return {
      gridType: GridType.Fit,
      compactType: CompactType.None,
      margin: 0,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      useTransformPositioning: true,
      mobileBreakpoint: 0,
      minCols: isPilotPanel ? 1 : GRID_WIDTH,
      maxCols: isPilotPanel ? 1 : GRID_WIDTH,
      minRows: GRID_HEIGHT,
      maxRows: GRID_HEIGHT,
      maxItemCols: GRID_WIDTH,
      minItemCols: 1,
      maxItemRows: GRID_HEIGHT,
      minItemRows: 1,
      maxItemArea: GRID_WIDTH * GRID_HEIGHT,
      minItemArea: 1,
      defaultItemCols: 10,
      defaultItemRows: 10,
      fixedColWidth: 105,
      fixedRowHeight: 105,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: false,
      draggable: {
         enabled: true,
      },
      resizable: {
         enabled: true,
      },
      swap: false,
      pushItems: false,
      disablePushOnDrag: true,
      disablePushOnResize: true,
      pushDirections: { north: false, east: false, south: false, west: false },
      pushResizeItems: false,
      displayGrid: DisplayGrid.None,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false,
   };
}

export function gridDefaultValueForInnerWallBrick() {
   const gridOptions = gridDefaultValue(false);
   gridOptions.margin = 3;

   return gridOptions;
}
